import Button from 'admin/components/common/Button';
import Text from 'admin/components/common/Text';
import { Icon } from 'admin/components/common/Icon';
import { Flex } from 'antd';
import css from './Modal.scss';

const PublishIssuesNotice = ({ count, onReview }: { count: number; onReview: () => void }) => {
	if (count === 0) return null;

	return (
		<Flex align="center" justify="center" gap={4} className={css.issuesNotice}>
			<Icon type="pf-error" width={22} color="var(--ra-color-error-ds)" />
			<Button
				className={css.reviewIssues}
				view="label-only"
				size="auto"
				textSize={Text.size.label}
				color={Text.color.white}
				onClick={onReview}
			>
				Review {count} story {count === 1 ? 'issue' : 'issues'}
			</Button>
		</Flex>
	);
};

export default PublishIssuesNotice;
